"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "m13.026 4.381 1.468 3.799a1 1 0 0 0 .774.627l4.152.667c.968.156 1.264 1.405.469 1.979l-3.041 2.192a1 1 0 0 0-.392 1.027l.961 4.345c.222 1.001-.925 1.734-1.74 1.113l-3.07-2.34a1 1 0 0 0-1.213 0l-3.07 2.34c-.816.621-1.963-.112-1.741-1.113l.96-4.345a1 1 0 0 0-.39-1.027L4.11 11.453c-.795-.574-.5-1.823.47-1.979l4.151-.667a1 1 0 0 0 .774-.627l1.468-3.799c.362-.938 1.69-.938 2.052 0m-2.587 4.16A2 2 0 0 1 8.89 9.794l-4.152.668a.1.1 0 0 0-.043.18l3.041 2.192a2 2 0 0 1 .783 2.054l-.961 4.345a.1.1 0 0 0 .158.101l3.07-2.34a2 2 0 0 1 2.425 0l3.07 2.34a.1.1 0 0 0 .159-.1l-.961-4.346a2 2 0 0 1 .783-2.054l3.04-2.192a.1.1 0 0 0-.042-.18l-4.152-.668A2 2 0 0 1 13.56 8.54l-1.468-3.799a.1.1 0 0 0-.186 0z"
}), 'Favourite');
